import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const QUESTIONS = [
    { id: 'industry', text: "Quel est votre secteur d'activité ?", placeholder: "Ex: Restauration, BTP, Immobilier..." },
    { id: 'target', text: "Qui est votre client idéal ?", placeholder: "Ex: Jeunes actifs, Retraités CSP+..." },
    { id: 'usps', text: "Vos 3 points forts uniques ?", placeholder: "Ex: Rapide, Écologique, Sur-mesure..." },
    { id: 'competitor', text: "Votre concurrent n°1 ?", placeholder: "Ex: L'entreprise d'à côté..." },
    { id: 'style', text: "Style souhaité en 3 mots ?", placeholder: "Ex: Moderne, Épuré, Luxueux..." },
];

export default function CommercialBriefPage() {
    const navigate = useNavigate();
    const [step, setStep] = useState(0);
    const [answers, setAnswers] = useState({});
    const [completed, setCompleted] = useState(false);

    const handleNext = (e) => {
        e.preventDefault();
        const currentQ = QUESTIONS[step];
        if (!answers[currentQ.id]) return; // Block empty

        if (step < QUESTIONS.length - 1) {
            setStep(step + 1);
        } else {
            setCompleted(true);
        }
    };

    const handleDownload = () => {
        window.print();
        // In reality, this would trigger a PDF download logic
    };

    if (completed) {
        return (
            <div style={{ minHeight: '100vh', width: '100vw', background: '#e2e8f0', color: '#1e293b', fontFamily: 'Inter, sans-serif', padding: 40, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                <div className="no-print" style={{ marginBottom: 20, display: 'flex', gap: 20 }}>
                    <button onClick={() => navigate('/commercial/launchpad')} style={{ padding: '10px 20px', borderRadius: 8, border: 'none', background: '#cbd5e1', cursor: 'pointer' }}>Retour</button>
                    <button onClick={handleDownload} style={{ padding: '10px 30px', borderRadius: 8, border: 'none', background: '#3b82f6', color: 'white', fontWeight: 700, cursor: 'pointer' }}>IMPRIMER / PDF 🖨️</button>
                </div>

                {/* PDF VIEW */}
                <div style={{ width: '210mm', minHeight: '297mm', background: 'white', padding: '20mm', boxShadow: '0 0 20px rgba(0,0,0,0.1)' }}>

                    {/* Header PDF */}
                    <div style={{ borderBottom: '2px solid #0f172a', paddingBottom: 20, marginBottom: 40, display: 'flex', justifyContent: 'space-between', alignItems: 'end' }}>
                        <div>
                            <div style={{ fontSize: '2rem', fontWeight: 900, color: '#0f172a' }}>CAHIER DES CHARGES</div>
                            <div style={{ fontSize: '1rem', opacity: 0.6 }}>Projet Web & Digital</div>
                        </div>
                        <div style={{ textAlign: 'right' }}>
                            <div style={{ fontWeight: 700 }}>InfoColab Agency</div>
                            <div>{new Date().toLocaleDateString()}</div>
                        </div>
                    </div>

                    {/* Content */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>
                        {QUESTIONS.map((q, idx) => (
                            <div key={idx} style={{ pageBreakInside: 'avoid' }}>
                                <div style={{ fontSize: '0.9rem', color: '#64748b', textTransform: 'uppercase', marginBottom: 5, fontWeight: 700 }}>{q.text}</div>
                                <div style={{ fontSize: '1.2rem', padding: 15, background: '#f8fafc', borderLeft: '4px solid #3b82f6' }}>
                                    {answers[q.id]}
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Footer PDF */}
                    <div style={{ marginTop: 80, borderTop: '1px solid #e2e8f0', paddingTop: 20, display: 'flex', justifyContent: 'space-between', fontSize: '0.8rem', opacity: 0.6 }}>
                        <div>Document confidentiel généré par L'Assistant Brief™</div>
                        <div>Page 1/1</div>
                    </div>

                </div>

                <style>{`
                    @media print {
                        body * { visibility: hidden; }
                        .no-print { display: none; }
                        div[style*="width: '210mm'"], div[style*="width: '210mm'"] * { visibility: visible; }
                        div[style*="width: '210mm'"] { position: absolute; left: 0; top: 0; margin: 0; padding: 0; box-shadow: none; width: 100%; min-height: 100%; }
                    }
                `}</style>
            </div>
        );
    }

    const q = QUESTIONS[step];

    return (
        <div style={{ height: '100vh', width: '100vw', background: '#0f172a', color: 'white', fontFamily: 'Inter, sans-serif', display: 'flex', flexDirection: 'column' }}>

            {/* Progress */}
            <div style={{ height: 5, background: '#1e293b' }}>
                <div style={{ height: '100%', background: '#3b82f6', width: `${((step) / QUESTIONS.length) * 100}%`, transition: 'width 0.3s' }} />
            </div>

            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 40 }}>

                <div style={{ width: '100%', maxWidth: 600 }}>
                    <div style={{ fontSize: '1.2rem', opacity: 0.5, marginBottom: 20 }}>Question {step + 1} / {QUESTIONS.length}</div>

                    <h1 className="animate-fade-up" style={{ fontSize: '2.5rem', fontWeight: 800, marginBottom: 40, lineHeight: 1.2 }}>
                        {q.text}
                    </h1>

                    <form onSubmit={handleNext}>
                        <input
                            autoFocus
                            type="text"
                            placeholder={q.placeholder}
                            value={answers[q.id] || ''}
                            onChange={e => setAnswers({ ...answers, [q.id]: e.target.value })}
                            style={{
                                width: '100%', padding: '25px', background: 'transparent', border: 'none', borderBottom: '2px solid rgba(255,255,255,0.2)',
                                fontSize: '2rem', color: 'white', outline: 'none', transition: 'border-color 0.2s'
                            }}
                            onFocus={e => e.target.style.borderBottomColor = '#3b82f6'}
                            onBlur={e => e.target.style.borderBottomColor = 'rgba(255,255,255,0.2)'}
                        />

                        <div style={{ marginTop: 60, display: 'flex', justifyContent: 'flex-end', gap: 20 }}>
                            {step > 0 && (
                                <button type="button" onClick={() => setStep(step - 1)} style={{ padding: '15px 30px', background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', color: 'white', borderRadius: 50, cursor: 'pointer' }}>Précédent</button>
                            )}
                            <button type="submit" style={{ padding: '15px 40px', background: 'white', color: 'black', border: 'none', borderRadius: 50, fontSize: '1.2rem', fontWeight: 700, cursor: 'pointer' }}>
                                {step === QUESTIONS.length - 1 ? 'TERMINER & GÉNÉRER' : 'SUIVANT →'}
                            </button>
                        </div>
                    </form>
                </div>

            </div>

            <button onClick={() => navigate('/commercial/launchpad')} style={{ position: 'fixed', bottom: 30, left: 30, background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.2)', cursor: 'pointer' }}>Quitter</button>

            <style>{`.animate-fade-up { animation: fadeUp 0.5s ease-out; } @keyframes fadeUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }`}</style>
        </div>
    );
}
